import SeoMetaData from "common/SeoMetaData"
import CreateAiPage from "components/CreateAi/CreateAiPage"

const CreateAi = () => {
  const seo = {
    title: "יצירת תמונה ב-AI",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI",
  }

  return (
    <>
      <SeoMetaData data={seo} />
      <CreateAiPage />
    </>
  )
}

export default CreateAi
